var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"secondary","small":""},on:{"click":_vm.togglePanels}},[(_vm.value.length > 0)?[_c('v-icon',[_vm._v("expand_less")]),_vm._v("\n    Затвори всички\n  ")]:[_c('v-icon',[_vm._v("expand_more")]),_vm._v("\n    Отвори всички\n  ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }